export type ThemeMode = 'light' | 'dark' | 'system';
const KEY = 'kt-theme-mode';

export function getThemeMode(): ThemeMode {
  if (typeof window === 'undefined') return 'light';
  return (localStorage.getItem(KEY) as ThemeMode) || 'light';
}

export function effectiveTheme(mode: ThemeMode): 'light' | 'dark' {
  if (mode === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return mode;
}

export function setThemeMode(mode: ThemeMode): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(KEY, mode);
  const eff = effectiveTheme(mode);
  document.documentElement.setAttribute('data-bs-theme', eff);
  document.documentElement.setAttribute('data-bs-theme-mode', mode);
  window.dispatchEvent(new CustomEvent('kt:theme-change', { detail: { mode, effective: eff } }));
}

export function initTheme(): void {
  // Já restaurado pelo inline script no index.html; aqui apenas re-aplica para garantir consistência.
  setThemeMode(getThemeMode());
}
